import {HighChartHandler} from '../../resources/config-schema';
import {IBaselineSubmissionProps, IFinaleSubmissionProps} from '../resources/Submission';

const sum = <T>(
    collection: T[],
    key: keyof T
): number => {
    return collection.reduce((acc, submission) => {
        const value = submission[key];
        return typeof value === 'number' ? acc + value : acc;
    }, 0);
};

/**
 * == baseline
 * question27_row_1_column_1 - Permanent contracts
 * question27_row_2_column_1 - Fix-term contracts
 * question27_total_column_1 - Total number of employees
 * 
 * == final
 * question84_row_1_column_1 - Permanent contracts
 * question84_row_2_column_1 - Fix-term contracts
 * question84_total_column_1 - Total number of employees
 * 
 * @param baselineSubmissions 
 * @param finalSubmissions 
 * @param title 
 * @returns
 */
export const termContractChartCalculation: HighChartHandler<IBaselineSubmissionProps, IFinaleSubmissionProps> =
    (baselineSubmissions, finalSubmissions, title) => {
        return {
            chart: {
                type: 'column',
            },
            title: {
                text: title,
                align: 'left',
            },
            tooltip: {
                formatter: function (){
                    let value = this.series.name + '<br />';
                    value += `<b>${this.point.y?.toFixed(2)} (${this.point.percentage?.toFixed(1)}%)</b>`;

                    return value;
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: '',
                },
            },
            xAxis: {
                categories: ['Baseline', 'Final'],
            },
            plotOptions: {
                column: {
                    stacking: 'percent',
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
            },
            series: [
                {
                    name: 'Fix-term contracts',
                    type: 'column',
                    color: '#ed7d32',
                    data: [
                        sum(baselineSubmissions, 'question27_row_2_column_1') / sum(baselineSubmissions, 'question27_total_column_1') * 100,
                        sum(finalSubmissions, 'question84_row_2_column_1') / sum(finalSubmissions, 'question84_total_column_1') * 100,
                    ],
                },
                {
                    name: 'Permanent contracts',
                    type: 'column',
                    color: '#5b9bd5',
                    data: [
                        sum(baselineSubmissions, 'question27_row_1_column_1') / sum(baselineSubmissions, 'question27_total_column_1') * 100,
                        sum(finalSubmissions, 'question84_row_1_column_1') / sum(finalSubmissions, 'question84_total_column_1') * 100,
                    ],
                },
            ],
        };
    }